// extracted by mini-css-extract-plugin
export default {"mainHeader":"MedicationCompounding_mainHeader__qEWtJ"};